import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface Holiday {
	calDt: string;
	calDtType: string;
	content: string;
	holiYn: string;
	lunaYn: string;
}

/** ```
 * 휴일 입력정보 조회
 *   `/esntl/api/contents/holiday/${yyyy}`
 * parameter
 *   `yyyy` 연도
 * ```*/
const key = "useContentsHoliday";
const getPath = (yyyy: string): string | null => {
	if (!yyyy) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/common/holiday/${yyyy}`;
};

/** ```
 * 휴일 입력정보 조회
 *   `/esntl/api/contents/holiday/${yyyy}`
 * parameter
 *   `yyyy` 연도
 * ```*/
const useContentsHoliday = (yyyy: string, options?: Partial<UseQueryOptions<Response<Holiday[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(yyyy)],
		queryFn: () => useConfigureAxios({url: getPath(yyyy)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useContentsHoliday;
export {getPath, key};
export type {Holiday};
